import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonCHL from './es/private/esCHL/common.es.json';
import coverageCHL from './es/private/esCHL/coverage.es.json';
import commonCOL from './es/private/esCOL/common.es.json';
import coverageCOL from './es/private/esCOL/coverage.es.json';
import additionalServices from './es/private/esGeneral/additionalServices.es.json';
import commonGeneral from './es/private/esGeneral/common.es.json';
import developers from './es/private/esGeneral/developers.es.json';
import falabella from './es/private/esGeneral/falabella.es.json';
import myShipments from './es/private/esGeneral/myShipments.es.json';
import orderSuccess from './es/private/esGeneral/orderSuccess.es.json';
import orderSummary from './es/private/esGeneral/orderSummary.es.json';
import originData from './es/private/esGeneral/originData.es.json';
import pickup from './es/private/esGeneral/pickup.es.json';
import receiverData from './es/private/esGeneral/receiverData.es.json';
import commonMEX from './es/private/esMEX/common.es.json';
import coverageMEX from './es/private/esMEX/coverage.es.json';
import commonPER from './es/private/esPER/common.es.json';
import coveragePER from './es/private/esPER/coverage.es.json';

const generalTranslations = {
  commonGeneral,
  pickup,
  myShipments,
  orderSuccess,
  developers,
  falabella,
  OriginData: originData,
  ReceiverData: receiverData,
  AdditionalServices: additionalServices,
  Summary: orderSummary,
};

i18n.use(initReactI18next).init({
  resources: {
    'es-MEX': {
      coverage: coverageMEX,
      common: commonMEX,
      ...generalTranslations,
    },
    'es-CHL': {
      coverage: coverageCHL,
      common: commonCHL,
      ...generalTranslations,
    },
    'es-COL': {
      coverage: coverageCOL,
      common: commonCOL,
      ...generalTranslations,
    },
    'es-PER': {
      coverage: coveragePER,
      common: commonPER,
      ...generalTranslations,
    },
    en: {},
  },
  lng: 'es-MEX',
  fallbackLng: 'es-MEX',
  ns: ['common', 'coverage', 'falabella', 'createOrder'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: true,
  },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'em', 'i', 'strong', 'a'],
  },
});

export default i18n;
